module.exports = __webpack_public_path__ + "img/house-tree.37e19787.svg";